export default __webpack_public_path__ + "static/media/greenfi.6718a40e.md";